import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Paper, Skeleton, Typography, alpha, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function PilotLockedView() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 1 }}>
      <Paper
        elevation={0}
        aria-label={t('pilot.lockedTitle')}
        sx={{ position: 'relative', minHeight: 560, overflow: 'hidden', borderRadius: 3 }}
      >
        <Box
          aria-hidden="true"
          sx={{
            position: 'absolute',
            inset: 0,
            p: 3,
            filter: 'blur(7px)',
            opacity: 0.7,
            pointerEvents: 'none',
          }}
        >
          <Skeleton variant="text" width="38%" height={42} />
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mt: 2 }}>
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} variant="rounded" height={180} />
            ))}
          </Box>
        </Box>
        <Box
          role="status"
          sx={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            px: 3,
            textAlign: 'center',
            bgcolor: alpha(theme.palette.background.paper, 0.76),
            backdropFilter: 'blur(2px)',
          }}
        >
          <Box
            sx={{
              width: 58,
              height: 58,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              bgcolor: alpha(theme.palette.primary.main, 0.12),
              color: 'primary.main',
            }}
          >
            <LockOutlinedIcon fontSize="large" />
          </Box>
          <Typography variant="h6" fontWeight={700}>
            {t('pilot.lockedTitle')}
          </Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 480 }}>
            {t('pilot.lockedMessage')}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
